import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    id="color-account"
    width="95.6"
    height="94.968"
    viewBox="0 0 95.6 94.968"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#00efd1" />
        <stop offset="1" stopColor="#00acea" />
      </linearGradient>
    </defs>
    <path
      id="Caminho_75"
      data-name="Caminho 75"
      d="M133.336,63.39a20.825,20.825,0,1,0-14.759-6.1A20.825,20.825,0,0,0,133.336,63.39Zm-11.9-32.748a16.856,16.856,0,1,1-4.908,11.89A16.856,16.856,0,0,1,121.436,30.642Z"
      transform="translate(-93.746 -21.738)"
      fill="url(#linear-gradient)"
    />
    <path
      id="Caminho_76"
      data-name="Caminho 76"
      d="M339.1,326.779a10.926,10.926,0,1,0,10.921,10.932A10.927,10.927,0,0,0,339.1,326.779Zm0,17.8a6.875,6.875,0,1,1,6.87-6.87A6.875,6.875,0,0,1,339.1,344.58Z"
      transform="translate(-265.749 -264.992)"
      fill="url(#linear-gradient)"
    />
    <path
      id="Caminho_77"
      data-name="Caminho 77"
      d="M112.764,264.758l2.621-2.515-3.5-8-3.637.26a18.426,18.426,0,0,0-2.91-2.773l.106-3.635-8.171-3.145-2.359,2.739a19.852,19.852,0,0,0-3.693.07c-.541-.6-1.121-1.192-1.764-1.794a30.5,30.5,0,0,0-13.975-7.543,2.025,2.025,0,0,0-1.63.319,24.4,24.4,0,0,1-28.3,0,2.025,2.025,0,0,0-1.63-.319A30.989,30.989,0,0,0,20,268.485v3.192a2.062,2.062,0,0,0,2.03,2.064H71.994l2.828,6.441,3.636-.269a18.4,18.4,0,0,0,2.91,2.768l-.106,3.631,8.16,3.146,2.36-2.74a20.257,20.257,0,0,0,4.019-.1l2.517,2.611,8-3.488-.272-3.639a18.063,18.063,0,0,0,2.777-2.918l3.626.106,3.147-8.159-2.739-2.359a19.893,19.893,0,0,0-.1-4.011Zm-88.713,3.727a26.8,26.8,0,0,1,5.938-16.764A27.121,27.121,0,0,1,43.8,242.633a28.422,28.422,0,0,0,31.639-.043,26.343,26.343,0,0,1,8.9,4.358l-3.955,1.732.271,3.633a18.127,18.127,0,0,0-2.782,2.911l-3.618-.106-3.162,8.158,2.746,2.365a20.42,20.42,0,0,0,.1,4.027l0,.02H24.051Zm85.654,6.669-2.972-.087-.622.942a14.067,14.067,0,0,1-3.369,3.545l-.9.665.221,2.956-2.786,1.215-2.041-2.118-1.066.192a16.236,16.236,0,0,1-4.976.123l-1.083-.141-1.9,2.2L85.4,283.563l.087-2.962-.929-.623a14.4,14.4,0,0,1-3.546-3.378l-.662-.891-2.959.211-1.22-2.787,2.13-2.049-.2-1.073a16.2,16.2,0,0,1-.13-4.966l.134-1.077-2.2-1.894L77,259.251l2.957.087.622-.934a14.121,14.121,0,0,1,3.38-3.537l.9-.665-.221-2.963,2.785-1.22,2.045,2.131,1.075-.2a15.826,15.826,0,0,1,4.953-.132l1.084.142,1.9-2.205,2.831,1.09-.087,2.961.929.623a14.4,14.4,0,0,1,3.546,3.378l.662.891,2.959-.211,1.224,2.79-2.131,2.044.2,1.075a15.867,15.867,0,0,1,.122,4.955l-.142,1.083,2.2,1.9Z"
      transform="translate(-20 -194.49)"
      fill="url(#linear-gradient)"
    />
  </svg>,
  'ColorAccountIcon',
);
